import {
    apiRequest,
    AcTeknisData,
    AcTeknisDetail,
    AcTeknisStankom,
    AcTeknisMatrix,
    AcDevGuideTeknis,
    SuitablePossisionTeknis
} from "../../../../../services/adapters/Assesment/assesmentService"

class DetailRepository {

    fetchAcData = async (query) => {
        return await apiRequest("get", AcTeknisData, {
            params: query
        }, true)
    }
    fetchAcDetail = async (query) => {
        return await apiRequest("get", AcTeknisDetail, {
            params: query
        }, true)
    }
    fetchStankom = async (query) => {
        return await apiRequest("get", AcTeknisStankom, {
            params: query
        }, true)
    }
    fetchMatrix = async (query) => {
        return await apiRequest("get", AcTeknisMatrix, {
            params: query
        }, true)
    }
    fetchDevGuide = async (query) => {
        return await apiRequest("get", AcDevGuideTeknis, {
            params: query
        }, true)
    }
    fetchSuitablePossision = async (query) => {
        return await apiRequest("get", SuitablePossisionTeknis, {
            params: query
        }, true)
    }
}

export default DetailRepository